import { render, staticRenderFns } from "./segment.vue?vue&type=template&id=168191b6&scoped=true"
import script from "./segment.vue?vue&type=script&lang=js"
export * from "./segment.vue?vue&type=script&lang=js"
import style0 from "./segment.vue?vue&type=style&index=0&id=168191b6&prod&lang=less&scoped=true"
import style1 from "./segment.vue?vue&type=style&index=1&id=168191b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168191b6",
  null
  
)

export default component.exports